<template>
  <div>

    <el-row>
      <el-row>
        <br>
        <el-form :inline="true"
                 class="demo-form-inline">
          <el-col :span="12">
            <el-form-item label="报告类型">
              <el-select v-model="reportType"
                         @change="getHtml"
                         placeholder="请选择">
                <el-option label="开盘股评"
                           value="0"></el-option>
                <el-option label="收盘股评"
                           value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  v-if="reportType==='0'">
            <el-form-item label="选择日期">

              <el-date-picker v-model="openDate"
                              @change="getHtml"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              type="date"
                              :picker-options="pickerOptions"
                              placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  v-if="reportType==='1'">
            <el-form-item label="选择日期">
              <el-date-picker v-model="closeDate"
                              @change="getHtml"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              type="date"
                              :picker-options="pickerOptions"
                              placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <br> <br>
      <el-row>
        <el-col :span="12">
          <template v-if="reportType==='0'">
            <div v-html="openHtml"></div>
          </template>
          <template v-if="reportType==='1'">
            <div v-html="closeHtml"></div>
          </template>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'ele',
  data: function () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      reportType: '0',
      openDate: '',
      openHtml: '',
      closeDate: '',
      closeHtml: ''
    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    }
  },
  components: {

  },
  computed: {

  },
  methods: {
    getHtml () {
      if (this.reportType === '0') {
        this.getOpenHtml()
      }
      if (this.reportType === '1') {
        this.getCloseHtml()
      }
    },
    getOpenHtml () {
      let _this = this
      if (!this.openDate) {
        _this.openHtml = '请选择开盘日期'
        return
      }
      axios.get('/api/web/stock/openClose?marketStatus=0&dateTime=' + this.openDate).then(resp => {
        _this.openDate = resp.data.date
        _this.openHtml = resp.data.html
      })
    },
    getCloseHtml () {
      let _this = this
      if (!this.closeDate) {
        _this.closeHtml = '请选择收盘日期'
        return
      }
      axios.get('/api/web/stock/openClose?marketStatus=1&dateTime=' + this.closeDate).then(resp => {
        _this.closeDate = resp.data.date
        _this.closeHtml = resp.data.html
      })
    }
  },

  mounted () {
    let _this = this
    axios.get('/api/web/stock/openClose?marketStatus=0&dateTime=' + this.openDate).then(resp => {
      _this.openDate = resp.data.date
      _this.openHtml = resp.data.html
    })
    axios.get('/api/web/stock/openClose?marketStatus=1&dateTime=' + this.closeDate).then(resp => {
      _this.closeDate = resp.data.date
      _this.closeHtml = resp.data.html
    })
  }
}
</script>
<style lang="less" scoped>
.openCloseIframe {
  border: 0px;
  width: 603px;
  height: calc(100vh - 203px);
}
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/perception.vue